module.exports = __webpack_public_path__ + "static/posters-b76eb82ef241136f8fbf80815df75947.png";